import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, startWith, switchMap, take } from 'rxjs/operators';

import { SELECT_AUTH_USER_ID } from '@store/authentication';
import { OnSiteLocationsService } from '@core/services/on-site-locations/on-site-locations.service';

import {
  CHECKS_PAGE_BLOCK_EMPTY_VM,
  CHECKS_PAGE_BLOCK_LOADING_VM,
  ChecksPageBlockDataSource,
  ChecksPageBlockViewModel,
} from './checks-page-block-view-model';

@Injectable()
export class ChecksPageBlockStoreDataSource implements ChecksPageBlockDataSource {
  readonly vm$: Observable<ChecksPageBlockViewModel> = this.store.select(SELECT_AUTH_USER_ID).pipe(
    take(1),
    switchMap(userId => {
      if (!userId) {
        return of(CHECKS_PAGE_BLOCK_EMPTY_VM);
      }

      return this.onSiteLocationsService.getUserChecks$(userId).pipe(
        map(checks => ({
          checks,
          isChecksLoading: false,
        })),
        startWith(CHECKS_PAGE_BLOCK_LOADING_VM),
        catchError(() => of(CHECKS_PAGE_BLOCK_EMPTY_VM)),
      );
    }),
  );

  constructor(
    private readonly store: Store,
    private readonly onSiteLocationsService: OnSiteLocationsService,
  ) {}
}
